import React from 'react'

export default function Error() {
   return (
      <>
      <div class="main-wrapper">
          <div class="error-box mt-20">
              <div class="error-box-img"><img class="img-fluid" src={"../../theme/assets/img/error-01.png"} alt="" /></div>
              <h3 class="h2 mb-3"> Oh No! Error 404</h3>
              <p class="h4 font-weight-normal">This page you requested counld not found. May the force be with you!</p>
          </div>
      </div>
      </>
   )
}
